import 'theme';

class HalloweenWarmUp extends HTMLElement {
  connectedCallback() {
    if (this.listeners) return;
    this.form = this.querySelector('.subscribe-form');
    if (!this.form) return;
    this.email = this.form.querySelector('[name="email"]');
    this.button = this.form.querySelector('[type="submit"]');
    this.status = this.form.querySelector('.subscribe-status');
    this.listeners = new AbortController();
    this.form.addEventListener('submit', (event) => this.submit(event), { signal: this.listeners.signal });
    this.email.addEventListener('input', () => this.showStatus(), { signal: this.listeners.signal });
  }

  disconnectedCallback() {
    this.listeners?.abort();
    this.listeners = null;
  }

  showStatus(message = '', state = '') {
    this.status.textContent = message;
    this.status.dataset.state = state;
    this.email.setAttribute('aria-invalid', String(state === 'invalid'));
  }

  async submit(event) {
    event.preventDefault();
    if (this.pending) return;
    const api = window.klaviyoApi;
    const email = this.email.value.trim();
    if (!api || !window.themeRequest || !this.dataset.companyId || !this.dataset.listId) {
      this.showStatus(this.dataset.failedMessage, 'error');
      return;
    }
    if (!api.isValidEmail(email)) {
      this.showStatus(this.dataset.invalidMessage, 'invalid');
      this.email.focus();
      return;
    }

    this.showStatus();
    this.pending = true;
    this.button.disabled = true;
    this.email.readOnly = true;
    this.form.setAttribute('aria-busy', 'true');
    try {
      // The shared API stores its configuration globally: set it before each request.
      api.init(this.dataset.companyId, this.dataset.listId);
      await api.createProfile(email);
      api.init(this.dataset.companyId, this.dataset.listId);
      await api.createSubscription(email);
      this.email.value = '';
      this.showStatus(this.dataset.successMessage, 'success');
    } catch {
      this.showStatus(this.dataset.failedMessage, 'error');
    } finally {
      this.pending = false;
      this.button.disabled = false;
      this.email.readOnly = false;
      this.form.setAttribute('aria-busy', 'false');
    }
  }
}

if (!customElements.get('halloween-warm-up')) {
  customElements.define('halloween-warm-up', HalloweenWarmUp);
}
